const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://ytuongqhbaisonghong-api.cgis.asia/",
  },
  production: {
      api: "https://ytuongqhbaisonghong-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
